import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';

import { deleteBCDataset } from '../../../../../actions/synchronisationActions';
import BCDatasetForm from './BCDatasetForm';

class BCDatasetTable extends Component {
  handleDelete = id => {
    const { storeId, sourceId, deleteBCDataset } = this.props;
    return () => {
      deleteBCDataset(storeId, id, sourceId);
    };
  };

  render() {
    const { datasets, storeId, sourceId } = this.props;
    // Sort overrides to the top so operators see tenant customizations without scrolling.
    // Stable order within each group is preserved by the array index tiebreaker.
    const sortedDatasets = datasets
      ? datasets
          .map((d, i) => ({ d, i }))
          .sort((a, b) => Number(!!b.d.isOverride) - Number(!!a.d.isOverride) || a.i - b.i)
          .map((x) => x.d)
      : [];
    return (
      <Table bordered style={{ marginTop: 10, tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th style={{ width: '14%' }}>Dataset Name</th>
            <th style={{ width: '16%' }}>Operation</th>
            <th style={{ width: '16%' }}>Changes Operation</th>
            <th style={{ width: '12%' }}>Id Field</th>
            <th style={{ width: '14%' }}>Timestamp Field</th>
            <th style={{ width: '10%' }}>cbaTableID</th>
            <th style={{ width: '8%' }}>Override</th>
            <th style={{ width: '10%' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          <BCDatasetForm storeId={storeId} sourceId={sourceId} />
          {sortedDatasets.map((dataset, idx) => (
              <tr key={dataset.id || `default-${dataset.datasetName || idx}`}>
                <td>{dataset.datasetName}</td>
                <td>{dataset.operation}</td>
                <td>{dataset.changesOperation}</td>
                <td>{dataset.idField}</td>
                <td>{dataset.timestampField}</td>
                <td>{dataset.cbaTableID}</td>
                <td>{dataset.isOverride ? 'Y' : null}</td>
                <td>
                  {dataset.isOverride && (
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: 'transparent' }}
                      onClick={this.handleDelete(dataset.id)}
                    >
                      <i className="fa-solid fa-xmark" />
                    </button>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  }
}

export default connect(
  state => ({
    datasets: state.sync.bcDataset.datasets
  }),
  dispatch => ({
    deleteBCDataset: (storeId, id, sourceId) => dispatch(deleteBCDataset(storeId, id, sourceId))
  })
)(BCDatasetTable);
